module.exports = __webpack_public_path__ + "img/retorno.cc358b27.svg";